import { BumpSettings } from "@/types/product";

export const getBumpSettings: BumpSettings = {
  enableBump: false,
  orderBumpStyle: "modern",
  bumpTemplate: "templateOne",
  highlightText: "Grab the deals with quick click!",
  showPrice: true,
  bumpPriceColor: "FF9900",
  bumpIconColor: "FFFFFF",
  bumpBackgroundColor: "444CE7",
  highlightTextColor: "FFFFFF",
  bumpIcon: "fire",
  bumpBorderColor: "444CE7",
  headlineColor: "101828",
  otoHeadlineColor: "004EEB",
  otoTextColor: "101828",
  highlightTemplateThreeColor: "101828",
};
